<app-header></app-header>
<div class="body-container clearfix">
    <div class="embed-responsive embed-responsive-docusign">
        <iframe title="docusign" class="embed-responsive-item" [src]="docuSignUrl" allowfullscreen></iframe>
    </div>
</div>
<app-footer></app-footer>